import { Link } from "react-router-dom";
import { useRealizacje } from "../Context/RealizacjeContext";
import "../pages/Realizacje.css"

const Realizacje = () => {
  const { realizacje, loading } = useRealizacje();

  if (loading) return <p>Ładowanie realizacji...</p>;

  return (
    <div className="box-menu">
      <div className="boxes-header">
        <h2>REALIZACJE</h2>
        <p>
          Wszystkie projekty realizuję indywidualnie, dlatego każda wycena
          dopasowywana jest do zakresu i potrzeb konkretnego Klienta.
        </p>
        <br />
        <p>Skontaktuj się ze mną, aby dostosować projekt do swoich potrzeb!</p>
      </div>

      <div className="boxes-menu">
        {realizacje.map(({ id, name, img }) => (
          <Link to={`/realizacje/${id}`} className="box" key={id}>
            <div
              className="box-bg"
              style={{ backgroundImage: `url(${img})` }}
            ></div>
            <div className="box-content">
              <p className="box-label">{name}</p>
              <button className="box-button">→</button>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Realizacje;
